import React from 'react'

export interface IconProps {
    width?: string | number;
    height?: string | number;
    className?: string;
}

export default function ReferAFriendIcon({
    width = 100,
    height = 100,
    className = '',
}: IconProps) {
    return (
        <svg
            version="1.0"
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 225.000000 154.000000"
            preserveAspectRatio="xMidYMid meet"
            className={`cursor-pointer group-hover:stroke-white transition duration-200 ${className}`}
        >
            <g transform="translate(0.000000,154.000000) scale(0.100000,-0.100000)" fill="#fff" stroke="none">
                <path d="M1131 1215 c-95 -111 -227 -221 -319 -266 -36 -17 -121 -47 -189 -65 -157 -42 -190 -59 -231 -118 -28 -43 -32 -56 -32 -115 0 -80 25 -129 87 -177 53 -40 124 -51 200 -31 l53 14 78 -161 c77 -159 87 -172 144 -189 29 -10 86 13 108 42 31 45 25 81 -40 217 -33 69 -60 128 -60 130 0 5 77 -4 150 -17 74 -14 199 -54 278 -90 78 -35 102 -36 130 -7 34 37 45 106 39 236 -14 322 -167 692 -286 692 -23 0 -42 -16 -110 -95z m146 23 c117 -127 229 -549 199 -750 -10 -63 -26 -84 -55 -69 -25 14 -83 100 -107 161 -16 39 -16 42 4 63 78 86 13 326 -96 354 -24 6 -24 6 -20 112 4 105 17 151 42 151 7 0 22 -10 33 -22z m-129 -170 c5 -168 64 -404 138 -549 23 -45 23 -51 7 -45 -64 25 -199 58 -278 68 -95 11 -163 5 -287 -25 l-56 -14 -36 151 c-20 83 -36 156 -36 161 0 6 34 18 75 28 144 34 253 98 385 225 47 45 85 81 85 82 0 0 1 -37 3 -82z m100 -151 c33 -35 52 -91 52 -154 0 -54 -12 -94 -24 -82 -3 3 -16 48 -30 100 -42 164 -42 183 2 136z m-665 -264 c42 -174 41 -178 -27 -168 -89 13 -146 75 -146 158 0 53 16 90 52 124 19 18 60 40 78 42 3 1 22 -70 43 -156z m315 -215 c12 -28 21 -52 20 -53 -14 -9 -101 -45 -103 -43 -1 2 -17 31 -33 65 l-31 61 37 10 c75 20 85 16 110 -40z m75 -153 c15 -31 27 -63 27 -72 0 -26 -31 -53 -61 -53 -22 0 -34 8 -52 38 -24 40 -50 94 -45 96 43 21 94 45 98 45 3 1 18 -24 33 -54z" />
                <path d="M1605 1238 c-71 -62 -89 -93 -61 -104 23 -9 166 115 163 141 -4 35 -31 25 -102 -37z" />
                <path d="M1725 951 c-70 -19 -85 -27 -85 -46 0 -23 27 -24 112 -2 69 18 83 25 83 42 0 26 -31 28 -110 6z" />
                <path d="M1673 644 c-9 -24 7 -33 96 -54 105 -25 111 -25 111 3 0 22 -9 26 -90 45 -107 26 -109 26 -117 6z" />
            </g>
        </svg>
    )
}